// De dónde salen estos números, y a dónde ir cuando hay que cuadrar.
//
// Aparece en Estadísticas, Caja y Resumen Diario: las tres pantallas donde un
// cliente compara contra lo que tiene en su PC y puede no darle igual.
//
// Lo que NO dice, a propósito: "estos datos pueden contener errores". Es la
// forma en que se explicaba de palabra, y tiene un problema — le resta
// confianza a TODO, incluso a los números que están perfectos, y deja al
// cliente sin saber cuándo dudar y cuándo no.
//
// La misma idea dicha como ORIGINAL vs COPIA se entiende igual de rápido, es
// literalmente cierta (la PC tiene el original, esto viajó por internet) y
// termina en una instrucción en vez de en una duda: para auditar, Informes.
//
// Las cuatro razones del desplegable son estructurales, no fallas. La primera
// es la que más veces genera el "no me coincide", y es una DEMORA, no una
// pérdida: el dato llega cuando la PC se reconecta.

import React, { useState } from "react";

const MOTIVOS = [
  {
    titulo: "Algo puede no haber llegado todavía.",
    detalle:
      "Si la PC estuvo apagada o sin internet, esos movimientos aparecen cuando vuelve a conectarse.",
  },
  {
    titulo: "El día en curso está incompleto.",
    detalle: "Se completa cuando cierra la jornada.",
  },
  {
    titulo: "Un turno que cruza la medianoche se reparte entre dos días.",
    detalle: "Si cierras a las 2 de la mañana, esa plata figura en el día siguiente.",
  },
  {
    titulo: "Los días en que TicketControl no estuvo abierto no tienen datos",
    detalle: "y no entran en ningún promedio ni comparación.",
  },
];

// Va al PIE de la pagina: `mt-4` separa del contenido de arriba y `mb-3` (16px)
// deja aire por debajo, para que no quede pegada al footer.
const NotaDatoOriginal = ({ className = "mt-4 mb-3" }) => {
  const [abierto, setAbierto] = useState(false);

  return (
    <div className={`${className} text-center text-muted`} style={{ fontSize: 12.5 }}>
      {/* Ancho de lectura acotado y centrado: a pantalla completa el renglon se
          estiraria de punta a punta y costaria seguirlo. */}
      <div className="mx-auto" style={{ maxWidth: 760 }}>
        <span
          className="material-symbols-rounded me-1"
          style={{ fontSize: 16, verticalAlign: "middle" }}
          aria-hidden="true"
        >
          info
        </span>
        Estos números viajan desde tu PC y sirven para ver cómo viene el negocio. Para
        auditar o cuadrar hasta el último movimiento, usa <strong>Informes</strong> en
        TicketControl: ahí está el dato original.{" "}
        <button
          type="button"
          onClick={() => setAbierto((v) => !v)}
          className="btn btn-link p-0 align-baseline"
          style={{ fontSize: 12.5 }}
          aria-expanded={abierto}
        >
          ¿Por qué puede no coincidir?
        </button>

        {abierto && (
          /* La lista va centrada como BLOQUE pero con el texto a la izquierda:
             renglones centrados con viñetas se leen mal. */
          <div className="mt-2">
            <ul className="text-start d-inline-block mb-0 ps-3" style={{ lineHeight: 1.5 }}>
              {MOTIVOS.map((m) => (
                <li key={m.titulo}>
                  <strong style={{ fontWeight: 600 }}>{m.titulo}</strong> {m.detalle}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotaDatoOriginal;
